module.exports = __webpack_public_path__ + "static/media/filter.b248ce53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/filter.png
// module id = 2981
// module chunks = 0